module.exports = __webpack_public_path__ + "img/background.d666437c.png";